var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.3333 14.6667H23.7333C25.2268 14.6667 25.9735 14.6667 26.5439 14.9573C27.0457 15.213 27.4536 15.6209 27.7093 16.1227C28 16.6931 28 17.4399 28 18.9333V28M17.3333 28V8.26667C17.3333 6.77319 17.3333 6.02646 17.0426 5.45603C16.787 4.95426 16.379 4.54631 15.8773 4.29065C15.3068 4 14.5601 4 13.0666 4H8.26663C6.77315 4 6.02642 4 5.45598 4.29065C4.95422 4.54631 4.54627 4.95426 4.29061 5.45603C3.99996 6.02646 3.99996 6.77319 3.99996 8.26667V28M29.3333 28H2.66663M8.66663 9.33333H12.6666M8.66663 14.6667H12.6666M8.66663 20H12.6666",
    stroke: "#A6A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.642691703c40f8160433bc092c80d298.svg";
export { ForwardRef as ReactComponent };